import { render, staticRenderFns } from "./BookingPassengerBlock.vue?vue&type=template&id=44d96cae&scoped=true&"
import script from "./BookingPassengerBlock.vue?vue&type=script&lang=ts&"
export * from "./BookingPassengerBlock.vue?vue&type=script&lang=ts&"
import style0 from "./BookingPassengerBlock.vue?vue&type=style&index=0&id=44d96cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d96cae",
  null
  
)

export default component.exports